module.exports = (__webpack_require__(30199))(20);